import { createAction } from '@reduxjs/toolkit';
import { GetUserClaimsReq, ClaimReq } from 'types/requests';
import actionTypes from './actionTypes';

export const getUserClaims = createAction<GetUserClaimsReq>(actionTypes.GET_USER_CLAIMS);
export const claim = createAction<ClaimReq>(actionTypes.CLAIM);
